import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import { Sidebar } from "./Sidebar";
import { PageEnter } from "../motion";
import { useNotificationSocket } from "../../hooks/useNotificationSocket";

const { Content } = Layout;

/**
 * The authenticated shell: a collapsible petrol rail and one content column.
 *
 * All navigation lives in the sidebar — there is no top bar, because a top bar
 * plus a rail gives a dealer two places to look for the same thing.
 *
 * Page-level chrome (title, description, actions) does **not** live here: it is
 * `PageHeader` from `components/Page`, rendered inside each page's `PageShell`.
 * That is what lets the dashboard and a plain form share the same rhythm while
 * still describing themselves differently.
 */
export function AppLayout() {
  useNotificationSocket();

  return (
    <Layout className="h-screen flex" style={{ background: "transparent", overflow: "hidden" }}>
      <Sidebar />
      {/* `min-w-0` so a wide table scrolls inside its own surface instead of
          stretching the column and pushing the rail off-screen. */}
      <Content className="min-w-0 flex-1 overflow-y-auto">
        <PageEnter>
          <Outlet />
        </PageEnter>
      </Content>
    </Layout>
  );
}
